import { DIRECTIONS } from '@blind-kings/game-core';

export const BOARD_H = 4;
export const BOARD_W = 8;
export const CELL_COUNT = BOARD_H * BOARD_W; // 32

/** Must match `PLANE_LAYOUT` / `SPATIAL_PLANES` in ai-training-v2/bk/env/features.py */
export const SPATIAL_CHANNELS = 36;
export const SPATIAL_PLANES = SPATIAL_CHANNELS;

/** Must match `GLOBAL_LAYOUT` / `GLOBAL_SIZE` in features.py */
export const GLOBAL_SIZE = 48;

export const NUM_ACTION_PLANES = 9;
export const ACTION_COUNT = NUM_ACTION_PLANES * CELL_COUNT; // 288

export const FLIP_OFFSET = 0;
export const MOVE_OFFSET = CELL_COUNT; // 32
export const ATTACK_OFFSET = CELL_COUNT + CELL_COUNT * 4; // 160

export const ARMY_SIZE = 16;
export const MAX_CP = 7;
export const TOTAL_MATERIAL = 52;
export const PROGRESS_SCALE = 256;

/** Direction order for action packing — must stay stable for trained weights. */
export const ACTION_DIRECTIONS = [
  DIRECTIONS.UP,
  DIRECTIONS.DOWN,
  DIRECTIONS.LEFT,
  DIRECTIONS.RIGHT,
] as const;

export type ActionDirection = (typeof ACTION_DIRECTIONS)[number];

export const CHANNEL = {
  OWN_CP0: 0,
  ENEMY_CP0: 7,
  UNTURNED: 14,
  EMPTY: 15,
  OWN_CP_SCALAR: 16,
  ENEMY_CP_SCALAR: 17,
  CHASE_INTENSITY: 18,
  CHASE_BLOCKED: 19,
  LEGAL_MASK: 20,
  ENEMY_CAN_CAPTURE: 29,
  OWN_CAN_CAPTURE: 30,
  CHEAPEST_ENEMY_ATTACKER: 31,
  ENEMY_ASSASSIN_REACH: 32,
  OWN_ASSASSIN_REACH: 33,
  LAST_ACTION_FROM: 34,
  LAST_ACTION_TO: 35,
} as const;
